import { takeLatest, all, put, select, call } from "redux-saga/effects";
import { createAction } from "redux-actions";

import axios from "axios";
import { queryParams } from "../../../utils/queryParams";
import moment from "moment";
import { API_DATE_FORMAT } from "../../../app_constants";

export const FETCH_ALL_LOCATIONS_TABLES_SUCCESS = "sagas/FETCH_ALL_LOCATIONS_TABLES_SUCCESS";
export const FETCH_ALL_LOCATIONS_DATA_SUCCESS = "sagas/FETCH_ALL_LOCATIONS_DATA_SUCCESS";
export const FETCH_ALL_LOCATIONS_DATA_FAILURE = "sagas/FETCH_ALL_LOCATIONS_DATA_FAILURE";
export const FETCH_ALL_LOCATIONS_TABLE_DATA = "sagas/FETCH_ALL_LOCATIONS_TABLE_DATA";
export const FETCH_FILTERS_UPDATE_SUCCESS = "sagas/FETCH_FILTERS_UPDATE_SUCCESS";
export const FETCH_OVERVIEW_TABLE_FAILURE = "sagas/FETCH_OVERVIEW_TABLE_FAILURE";
export const FETCH_OVERVIEW_TABLE_SUCCESS = "sagas/FETCH_OVERVIEW_TABLE_SUCCESS";
export const FETCH_OVERVIEW_DATA_SUCCESS = "saga/FETCH_OVERVIEW_DATA_SUCCESS";
export const FETCH_SCORECARDS_SUCCESS = "sagas/FETCH_SCORECARDS_SUCCESS";
export const FETCH_FILTERS_SUCCESS = "sagas/FETCH_FILTERS_SUCCESS";
export const FETCH_FILTERS_FAILURE = "sagas/FETCH_FILTERS_FAILURE";
export const FETCH_OVERVIEW_DATA = "saga/FETCH_OVERVIEW_DATA";

export const SET_ALL_CURRENTLY_LOADED_LOCATION_TABLES =
  "sagas/SET_ALL_CURRENTLY_LOADED_LOCATION_TABLES";
export const SET_MORE_LOCATIONS_TABLE_LOADING = "sagas/SET_MORE_LOCATIONS_TABLE_LOADING";
export const SET_SECOND_LEVEL_FILTERS_LOADING = "sagas/SET_SECOND_LEVEL_FILTERS_LOADING";
export const SET_THIRD_LEVEL_FILTERS_LOADING = "sagas/SET_THIRD_LEVEL_FILTERS_LOADING";
export const SET_FOURTH_LEVEL_FILTERS_LOADING = "sagas/SET_FOURTH_LEVEL_FILTERS_LOADING";
export const SET_ALL_LOCATION_TABLES_LOADING = "saga/SET_ALL_LOCATION_TABLES_LOADING";
export const SET_SELECTED_RANGE_OPTION = "sagas/SET_SELECTED_RANGE_OPTION";
export const SET_FILTERS_LOADING = "saga/SET_FILTERS_LOADING";
export const SET_TABLES_LOADING = "saga/SET_TABLES_LOADING";
export const SET_FILTERS_DIRTY = "saga/SET_FILTERS_DIRTY";
export const SET_LOADING = "saga/SET_LOADING";
export const SET_DATES = "saga/SET_DATES";

export const UPDATE_SELECTED_SECOND_LEVEL_FILTERS = "saga/UPDATE_SELECTED_SECOND_LEVEL_FILTERS";
export const UPDATE_SELECTED_FOURTH_LEVEL_FILTERS = "saga/UPDATE_SELECTED_FOURTH_LEVEL_FILTERS";
export const UPDATE_SELECTED_FIRST_LEVEL_FILTERS = "saga/UPDATE_SELECTED_FIRST_LEVEL_FILTERS";
export const UPDATE_SELECTED_THIRD_LEVEL_FILTERS = "saga/UPDATE_SELECTED_THIRD_LEVEL_FILTERS";
export const UPDATE_SELECTED_FIFTH_LEVEL_FILTERS = "saga/UPDATE_SELECTED_FIFTH_LEVEL_FILTERS";
export const UPDATE_CUSTOM_RANGE = "sagas/UPDATE_CUSTOM_RANGE";
export const UPDATE_FILTERS = "saga/UPDATE_FILTERS";
export const UPDATE_TABLES = "saga/UPDATE_TABLES";
export const UPDATE_DATES = "saga/UPDATE_DATES";
export const UPDATE_GROUP_BY = "saga/UPDATE_GROUP_BY";

export const CLEAR_ALL_LOCATIONS_TABLE_DATA = "sagas/CLEAR_ALL_LOCATIONS_TABLE_DATA";
export const CLEAR_RANGE_OPTIONS = "sagas/CLEAR_RANGE_OPTIONS";
export const CLEAR_ALL_LOCATIONS_TABLES = "sagas/CLEAR_ALL_LOCATIONS_TABLES";
export const LOAD_MORE_LOCATIONS = "sagas/LOAD_MORE_LOCATIONS";

export const actionCreators = {
  fetchOverviewData: createAction(FETCH_OVERVIEW_DATA),
  updateDates: createAction(UPDATE_DATES),
  requestNewTableData: createAction(UPDATE_TABLES),
  getAllLocationsTableData: createAction(FETCH_ALL_LOCATIONS_TABLE_DATA),
  updateSelectedFirstLevelFilters: createAction(UPDATE_SELECTED_FIRST_LEVEL_FILTERS),
  updateSelectedSecondLevelFilters: createAction(UPDATE_SELECTED_SECOND_LEVEL_FILTERS),
  updateSelectedThirdLevelFilters: createAction(UPDATE_SELECTED_THIRD_LEVEL_FILTERS),
  updateSelectedFourthLevelFilters: createAction(UPDATE_SELECTED_FOURTH_LEVEL_FILTERS),
  updateSelectedFifthLevelFilters: createAction(UPDATE_SELECTED_FIFTH_LEVEL_FILTERS),
  updateGroupBy: createAction(UPDATE_GROUP_BY),
  updateFiltersRequest: createAction(UPDATE_FILTERS),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  loadMoreLocationRequest: createAction(LOAD_MORE_LOCATIONS)
};

export default function* watchSummary() {
  yield takeLatest(FETCH_OVERVIEW_DATA, getOverviewData);
  yield takeLatest(UPDATE_TABLES, updateTables);
  yield takeLatest(UPDATE_FILTERS, updateFilters);
}

function getIds(data) {
  let ids = "";
  data.map((item) => {
    ids = ids + `${item.id},`;
  });
  return ids;
}

/**
 * @returns Array [
 *  id,
 *  selectedLevelFirst,
 *  selectedLevelSecond,
 *  selectedLevelThird,
 *  selectedLevelFourth,
 *  selectedLevelFifth,
 *  startDate,
 *  endDate
 * ]
 */
function* getApiArguments() {
  return yield select((state) => [
    state.commonReducer.commonProps.organization_id,
    state.multiLocationOverview.selectedLevelFirst,
    state.multiLocationOverview.selectedLevelSecond,
    state.multiLocationOverview.selectedLevelThird,
    state.multiLocationOverview.selectedLevelFourth,
    state.multiLocationOverview.selectedLevelFifth,
    state.multiLocationOverview.selectedRequestDates.startDate,
    state.multiLocationOverview.selectedRequestDates.endDate
  ]);
}

export function* getOverviewData({ payload }) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: SET_ALL_LOCATION_TABLES_LOADING, payload: true });
  yield put({ type: CLEAR_ALL_LOCATIONS_TABLE_DATA, payload: [] });
  yield put({ type: SET_FILTERS_LOADING, payload: true });
  yield put({ type: FETCH_OVERVIEW_DATA_SUCCESS, payload: payload });
  yield put({ type: SET_ALL_CURRENTLY_LOADED_LOCATION_TABLES, payload: 0 });

  const endDate = yield select((state) => state.multiLocationOverview.currentUser.calendarEndDate);
  const startDate = moment(endDate).subtract(4, "months").startOf("month").format(API_DATE_FORMAT);
  yield put({
    type: SET_DATES,
    payload: {
      startDate: moment(endDate).subtract(4, "months").startOf("month").format(API_DATE_FORMAT),
      endDate: endDate
    }
  });

  yield put({
    type: CLEAR_RANGE_OPTIONS,
    payload: {}
  });

  yield put({
    type: SET_SELECTED_RANGE_OPTION,
    payload: { startDate: startDate, endDate: endDate }
  });

  const id = yield select((state) => state.commonReducer.commonProps.organization_id);

  const getFiltersSaga = [getFilters(id)];
  try {
    // First get filters
    yield all(getFiltersSaga);

    const [, firstLevel, secondLevel, thirdLevel, fourthLevel, fifthLevel] =
      yield getApiArguments();

    // Then get overview card and table data
    try {
      const allSagas = [
        getOverviewTable(
          id,
          firstLevel,
          secondLevel,
          thirdLevel,
          fourthLevel,
          fifthLevel,
          startDate,
          endDate
        )
      ];
      yield all(allSagas);
      yield put({ type: SET_LOADING, payload: false });
      try {
        yield getAllLocationsTable(
          id,
          firstLevel,
          secondLevel,
          thirdLevel,
          fourthLevel,
          fifthLevel,
          startDate,
          endDate
        );
        yield put({ type: SET_ALL_LOCATION_TABLES_LOADING, payload: false });
      } catch (error) {
        console.error(error);
      }
    } catch (error) {
      console.error(error);
    }
  } catch (error) {
    console.error(error);
  }
}

export function* getFilters(orgId) {
  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "reports/locational/settings/get_filters",
      { organization_id: orgId.toString() }
    );
    yield put({ type: FETCH_FILTERS_SUCCESS, payload: response.data.filters });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_FILTERS_FAILURE, error });
  }
}

export function* getOverviewTable(
  id,
  firstLevel,
  secondLevel,
  thirdLevel,
  fourthLevel,
  fifthLevel,
  startDate,
  endDate
) {
  const [firstLevelParam, secondLevelParam, thirdLevelParam, fourthLevelParam] = yield select(
    (state) => state.multiLocationOverview.availableFilters.filter_params
  );

  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "reports/locational/overview/table",
      {
        organization_id: id.toString(),
        [firstLevelParam]: getIds(firstLevel),
        [secondLevelParam]: getIds(secondLevel),
        [thirdLevelParam]: getIds(thirdLevel),
        [fourthLevelParam]: getIds(fourthLevel),
        metrics: getIds(fifthLevel),
        start_date: startDate.toString(),
        end_date: endDate.toString()
      }
    );
    yield put({ type: FETCH_OVERVIEW_TABLE_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_OVERVIEW_TABLE_FAILURE, error });
  }
}

export function* getAllLocationsTable(
  id,
  firstLevel,
  secondLevel,
  thirdLevel,
  fourthLevel,
  fifthLevel,
  startDate,
  endDate
) {
  const group_by = yield select((state) => state.multiLocationOverview.groupBy.value.id);
  const [firstLevelParam, secondLevelParam, thirdLevelParam, fourthLevelParam] = yield select(
    (state) => state.multiLocationOverview.availableFilters.filter_params
  );

  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "reports/locational/overview/table",
      {
        organization_id: id.toString(),
        [firstLevelParam]: getIds(firstLevel),
        [secondLevelParam]: getIds(secondLevel),
        [thirdLevelParam]: getIds(thirdLevel),
        [fourthLevelParam]: getIds(fourthLevel),
        metrics: getIds(fifthLevel),
        start_date: startDate.toString(),
        end_date: endDate.toString(),
        split: true,
        one_table: fifthLevel.length === 1,
        group_by
      }
    );

    yield put({ type: FETCH_ALL_LOCATIONS_DATA_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_ALL_LOCATIONS_DATA_FAILURE, error });
  }
}

export function* updateTables() {
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({ type: SET_TABLES_LOADING, payload: true });
  yield put({ type: SET_ALL_LOCATION_TABLES_LOADING, payload: true });
  yield put({ type: SET_ALL_CURRENTLY_LOADED_LOCATION_TABLES, payload: 0 });
  yield put({ type: CLEAR_ALL_LOCATIONS_TABLES, payload: [] });

  const [id, firstLevel, secondLevel, thirdLevel, fourthLevel, fifthLevel, startDate, endDate] =
    yield getApiArguments();

  const allSagas = [
    getOverviewTable(
      id,
      firstLevel,
      secondLevel,
      thirdLevel,
      fourthLevel,
      fifthLevel,
      startDate,
      endDate
    ),
    getAllLocationsTable(
      id,
      firstLevel,
      secondLevel,
      thirdLevel,
      fourthLevel,
      fifthLevel,
      startDate,
      endDate
    )
  ];
  try {
    // effects will get executed in parallel
    yield all(allSagas);
    yield put({ type: SET_TABLES_LOADING, payload: false });
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
    yield put({ type: SET_ALL_LOCATION_TABLES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateFilters(payload) {
  const id = yield select((state) => state.commonReducer.commonProps.organization_id);

  if (payload.payload.name === "FilterLevelFirst") {
    yield put({
      type: UPDATE_SELECTED_FIRST_LEVEL_FILTERS,
      payload: payload.payload.data
    });

    yield put({ type: SET_SECOND_LEVEL_FILTERS_LOADING, payload: true });
    yield put({ type: SET_THIRD_LEVEL_FILTERS_LOADING, payload: true });
    yield put({ type: SET_FOURTH_LEVEL_FILTERS_LOADING, payload: true });

    yield getFiltersByFirstLevel(id, payload.payload.data);
  }

  if (payload.payload.name === "FilterLevelSecond") {
    yield put({
      type: UPDATE_SELECTED_SECOND_LEVEL_FILTERS,
      payload: payload.payload.data
    });

    yield put({ type: SET_THIRD_LEVEL_FILTERS_LOADING, payload: true });
    yield put({ type: SET_FOURTH_LEVEL_FILTERS_LOADING, payload: true });
    yield getFiltersBySecondLevel(id, payload.payload.data);
  }

  if (payload.payload.name === "FilterLevelThird") {
    yield put({
      type: UPDATE_SELECTED_THIRD_LEVEL_FILTERS,
      payload: payload.payload.data
    });

    yield put({ type: SET_FOURTH_LEVEL_FILTERS_LOADING, payload: true });
    yield getFiltersByThirdLevel(id, payload.payload.data);
  }
}

function* getFiltersByFirstLevel(orgId, payload) {
  const firstLevelParam = yield select(
    (state) => state.multiLocationOverview.availableFilters.filter_params[0]
  );
  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "reports/locational/settings/get_filters",
      {
        organization_id: orgId.toString(),
        [firstLevelParam]: getIds(payload)
      }
    );
    const filters = response.data.filters;

    yield put({ type: FETCH_FILTERS_UPDATE_SUCCESS, payload: filters });
    yield put({ type: UPDATE_SELECTED_SECOND_LEVEL_FILTERS, payload: filters.filters.level_2 });
    yield put({ type: UPDATE_SELECTED_THIRD_LEVEL_FILTERS, payload: filters.filters.level_3 });
    yield put({ type: UPDATE_SELECTED_FOURTH_LEVEL_FILTERS, payload: filters.filters.level_4 });

    yield put({ type: SET_SECOND_LEVEL_FILTERS_LOADING, payload: false });
    yield put({ type: SET_THIRD_LEVEL_FILTERS_LOADING, payload: false });
    yield put({ type: SET_FOURTH_LEVEL_FILTERS_LOADING, payload: false });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_FILTERS_FAILURE, error });
  }
}

export function* getFiltersBySecondLevel(orgId, payload) {
  const selectedFirstLevel = yield select(
    (state) => state.multiLocationOverview.selectedLevelFirst
  );
  const [firstLevelParam, secondLevelParam] = yield select(
    (state) => state.multiLocationOverview.availableFilters.filter_params
  );

  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "reports/locational/settings/get_filters",
      {
        organization_id: orgId.toString(),
        [firstLevelParam]: getIds(selectedFirstLevel),
        [secondLevelParam]: getIds(payload)
      }
    );
    const filters = response.data.filters;

    yield put({ type: FETCH_FILTERS_UPDATE_SUCCESS, payload: filters });
    yield put({ type: UPDATE_SELECTED_THIRD_LEVEL_FILTERS, payload: filters.filters.level_3 });
    yield put({ type: UPDATE_SELECTED_FOURTH_LEVEL_FILTERS, payload: filters.filters.level_4 });
    yield put({ type: SET_THIRD_LEVEL_FILTERS_LOADING, payload: false });
    yield put({ type: SET_FOURTH_LEVEL_FILTERS_LOADING, payload: false });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_FILTERS_FAILURE, error });
  }
}

export function* getFiltersByThirdLevel(orgId, payload) {
  const selectedFirstLevel = yield select(
    (state) => state.multiLocationOverview.selectedLevelFirst
  );
  const selectedSecondLevel = yield select(
    (state) => state.multiLocationOverview.selectedLevelSecond
  );

  const [firstLevelParam, secondLevelParam, thirdLevelParam] = yield select(
    (state) => state.multiLocationOverview.availableFilters.filter_params
  );

  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "reports/locational/settings/get_filters",
      {
        organization_id: orgId.toString(),
        [firstLevelParam]: getIds(selectedFirstLevel),
        [secondLevelParam]: getIds(selectedSecondLevel),
        [thirdLevelParam]: getIds(payload)
      }
    );
    const filters = response.data.filters;

    yield put({ type: FETCH_FILTERS_UPDATE_SUCCESS, payload: filters });
    yield put({ type: UPDATE_SELECTED_FOURTH_LEVEL_FILTERS, payload: filters.filters.level_4 });
    yield put({ type: SET_FOURTH_LEVEL_FILTERS_LOADING, payload: false });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_FILTERS_FAILURE, error });
  }
}
